import * as React from "react";
import { ScoreOption } from "../../services/product";
import { CardWrap, CardWrapWithMobile, StarHolder } from "./styles";

export interface CommentStarProps {
	rateScore: number;
	settingOption: ScoreOption;
	children?: JSX.Element;
}

export const CommentStarForWeb = (props: CommentStarProps) => {
	return (
		<CardWrap key={"commentStar"}>
			<>{RenderStart({ ...props, width: "10px" })}</>
			{props.children}
		</CardWrap>
	);
};
export const CommentStarForM = (props: CommentStarProps) => {
	return (
		<CardWrapWithMobile key={"commentStar"}>
			<>{RenderStart({ ...props, width: "0.625rem" })}</>
			{props.children}
		</CardWrapWithMobile>
	);
};

function RenderStart(props: CommentStarProps & { width: string }) {
	const { rateScore, settingOption = {}, width } = props;
	return [1, 2, 3, 4, 5].map((i, idx) => {
		if (rateScore >= i) {
			return (
				<StarHolder
					key={idx}
					{...settingOption}
					className={"iconfont icon-ic_star"}
					width={width}
				/>
			);
		}
		if (Math.ceil(rateScore) === i) {
			const percentWidth = (rateScore - i + 1).toFixed(2);
			return (
				<StarHolder
					key={idx}
					{...settingOption}
					width={width}
					className={"iconfont icon-ic_star_unselect"}
				>
					<span
						className={"iconfont icon-ic_star"}
						style={{ width: `${+percentWidth * 90}%` }}
					/>
				</StarHolder>
			);
		}
		return (
			<StarHolder
				key={idx}
				{...settingOption}
				width={width}
				className={"iconfont icon-ic_star_unselect"}
			></StarHolder>
		);
	});
}
